export class TableAction {
  name: string = '';
  title?: string;
  icon?: string;
  tooltip?: string;
  toggle?: string;
  default?: string;
  show?: boolean;
  badge?: boolean;
}
